import React from 'react';
import indexRoutes from './routes/';
import { Router, Route, Switch } from "react-router-dom";
import { Provider } from "react-redux";
import { configureStore } from "./redux/store";
import { history } from './jwt/_helpers';
import { PrivateRoute } from './routes/PrivateRoutes';
import Blanklayout from './layouts/blanklayout';
import HttpsRedirect from 'react-https-redirect';

class App extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentUser: null
        };
    }


    render() {
        const hostname = window.location.hostname || "";
        const isPrivateIpv4 =
            /^192\.168\./.test(hostname) ||
            /^10\./.test(hostname) ||
            /^172\.(1[6-9]|2[0-9]|3[0-1])\./.test(hostname);
        const shouldBypassHttpsRedirect =
            hostname === "localhost" ||
            hostname === "127.0.0.1" ||
            hostname.endsWith(".local") ||
            isPrivateIpv4;

        const appContent = (
            <Provider store={configureStore()}>
                <Router basename="/" history={history}>
                    <Switch>
                        <Route path="/authentication/login" component={Blanklayout} />;

                        {indexRoutes.map((prop, key) => {
                            return <PrivateRoute path={prop.path} key={key} component={prop.component} />;
                        })
                      }
                    </Switch>
                </Router>
            </Provider>
        );

        if (shouldBypassHttpsRedirect) {
            return appContent;
        }

        return <HttpsRedirect>{appContent}</HttpsRedirect>
    }
}

export default App;
